
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { proxyServer } from "../../../assets/constantes";
import { Spinner } from "react-bootstrap";



const initAction = {
  create: false,
  consult: false,
  edit: false,
};
const initPaises = {
  mexico: false,
  colombia: false,
  peru: false,
  chile: false,
};

const initDataForm = {
  email: "",
  password: "",
  estatus: "",
  role: "basic",
  paises: [],
};

const regexPassword =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()-_+=])[A-Za-z\d!@#$%^&*()-_+=]{8,}$/;
const emailRegex = /^\w+([._-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;

const CreateEditMonitorUser = () => {
  const [action, setAction] = useState(initAction);
  const [editPassword, setEditPassword] = useState(false);
  const [paises, setPaises] = useState(initPaises);
  const [dataForm, setDataForm] = useState(initDataForm);
  const [errorValidation, setErrorValidation] = useState("");
  const [errorResponse, setErrorResponse] = useState("");
  const [successResponse, setSuccessResponse] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (errorValidation !== "") {
      //console.log("errorValidation:...", errorValidation);
    }
  }, [errorValidation]);
  useEffect(() => {
    //console.log("dataForm:...", dataForm);
  }, [dataForm]);
  useEffect(() => {
    //eliminar el mensaje de successResponse
    if (successResponse !== "") {
      setTimeout(() => {
        setSuccessResponse("");
      }, 7000);
    }
  }, [successResponse]);
  const handleAction = (e) => {
    setAction({
      ...initAction,
      [e.target.name]: e.target.checked,
    });
  };
  const handlePaises = (e) => {
    const objPaises = {
        ...paises,
        [e.target.name]: e.target.checked,
        };
    setPaises(objPaises);
    let arrayPaises= [];
    for (const key in objPaises) {
        if(objPaises[key]){
            if(key === "mexico") arrayPaises.push("MX");
            if(key === "colombia") arrayPaises.push("CO");
            if(key === "peru") arrayPaises.push("PE");
            if(key === "chile") arrayPaises.push("CH");
        }
    }
    setDataForm({
        ...dataForm,
        paises: arrayPaises,
    });
  };
  const validaFormulario = () => {

    if (!emailRegex.test(dataForm.email)) {
        setErrorValidation("Favor de ingresar un email valido");
        return false;
      }
      if (!regexPassword.test(dataForm.password)&&!action.consult&&editPassword) {
        setErrorValidation("Favor de ingresar un password valido");
        return false;
      }
      if(action.create&&!regexPassword.test(dataForm.password)){
        setErrorValidation("Favor de ingresar un password valido");
        return false;
      }
        if (dataForm.estatus === ""&& action.create) {
            setErrorValidation("Favor de seleccionar un estatus");
            return false;
        }
        if (dataForm.role === "" && action.create) {
            setErrorValidation("Favor de seleccionar un role");
            return false;
        }
        if (dataForm.paises.length === 0 && action.create) {
            setErrorValidation("Favor de seleccionar al menos un pais");
            return false;
        }
        setErrorValidation("");
      return true;
  };
  const handleDataForm = (e) => {
    const { name, value } = e.target;
    
    setDataForm({
      ...dataForm,
      [name]: value,
    });
  };
  const handleSubmit = async(e) => {
    e.preventDefault();
    setLoading(true);
    try{
        const isValidForm=validaFormulario();
        if(!isValidForm) {
            setLoading(false);
          return;
        }
        console.log('dataForm:...',dataForm);
        console.log('action:...',action);
        console.log('Se procede a enviar la data al servidor');
        let dataBody={};
        let dataResponse={};
        if(action.create){
            dataBody.user=dataForm.email;
            dataBody.password=dataForm.password;
            dataBody.estatus=dataForm.estatus;
            dataBody.role=dataForm.role;
            dataBody.paises=dataForm.paises;
            dataResponse = await axios.post(`${proxyServer}api/createMonitorUser`,dataBody);
            setLoading(false);
            if(dataResponse?.data?.msg){
              setSuccessResponse(dataResponse.data.msg);
          }
        }
        if(action.edit){
            dataBody.user=dataForm.email;
            dataBody.password=dataForm.password;
            dataBody.estatus=dataForm.estatus;
            dataBody.role=dataForm.role;
            dataBody.paises=dataForm.paises;
            dataResponse = await axios.put(`${proxyServer}api/updateMonitorUser`,dataBody);
            setLoading(false);
            if(dataResponse?.data?.msg){
                setSuccessResponse(dataResponse.data.msg);
            }
        }
        if(action.consult){
            dataResponse = await axios.get(`${proxyServer}api/getMonitorUser/${dataForm.email}`);
            setLoading(false);
            if(dataResponse?.data?.result){
              setSuccessResponse(dataResponse.data.msg||'');
                const dataUserMonitor=dataResponse.data.result;
                let objPaises = {...initPaises};
                if(dataUserMonitor?.paises.includes("MX")) objPaises.mexico=true;
                if(dataUserMonitor?.paises.includes("CO")) objPaises.colombia=true;
                if(dataUserMonitor?.paises.includes("PE")) objPaises.peru=true;
                if(dataUserMonitor?.paises.includes("CH")) objPaises.chile=true;
                setPaises(objPaises);
                setDataForm({
                    email: dataUserMonitor?.user,
                    password: "",
                    estatus: dataUserMonitor?.estatus,
                    role: dataUserMonitor?.role,
                    paises: dataUserMonitor?.paises,
                });
            
            }
        }
        console.log('dataResponse:...',dataResponse);
        
        setLoading(false);
    }catch(error){
        console.log(error);
        const statusResponse = error.response.status;
        const msgError = error.response.data.msg;
        console.log("statusResponse:...", statusResponse);
        console.log("msgError:...", msgError);
        setErrorResponse(msgError);
        setLoading(false);
    }

  };

  const handleLimpiar = () => {
    setAction(initAction);
    setEditPassword(false);
    setPaises(initPaises);
    setDataForm(initDataForm);
    setErrorValidation("");
    setErrorResponse("");
    setSuccessResponse("");
  };

  return (
    <div className="card w-75 ms-auto me-auto p-2 bg-light">
      <Form onSubmit={handleSubmit} onReset={handleLimpiar}>
        <Form.Group className="mb-3 d-flex justify-content-center align-items-center gap-2">
          <Form.Check
            name="create"
            checked={action.create}
            onChange={handleAction}
            type="checkbox"
            label="Crear"
          />
          <Form.Check
            name="consult"
            checked={action.consult}
            onChange={handleAction}
            type="checkbox"
            label="Consultar"
          />
          <Form.Check
            name="edit"
            checked={action.edit}
            onChange={handleAction}
            type="checkbox"
            label="Editar"
          />
        </Form.Group>
        {action.edit && (
          <Form.Group
            className="mb-3 d-flex justify-content-center"
            controlId="formBasicName"
          >
            <Form.Check
              name="changePassword"
              checked={editPassword}
              onChange={() => setEditPassword((prev) => !prev)}
              type="checkbox"
              label="Editar Password"
            />
          </Form.Group>
        )}
        {errorValidation && (
          <div className="text-danger text-center w-100">{errorValidation}</div>
        )}
        {errorResponse && (
          <div className="text-danger text-center w-100">{errorResponse}</div>
        )}
        {successResponse && (
          <div className="text-success text-center w-100">{successResponse}</div>
        )}
        {loading && (
            <div className="d-flex justify-content-center">
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        {(action.create || action.edit || action.consult) && (
          <div>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>User email</Form.Label>
              <Form.Control
                onChange={handleDataForm}
                value={dataForm.email}
                name="email"
                type="email"
                placeholder="Enter email"
              />
              
            </Form.Group>

            {(action.create || editPassword) && (
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  onChange={handleDataForm}
                    value={dataForm.password}
                  name="password"
                  type="password"
                  placeholder="Password"
                />
              </Form.Group>
            )}

            <Form.Group className="mb-3">
              <Form.Label>Estatus</Form.Label>
              <Form.Select
                onChange={handleDataForm}
                value={dataForm.estatus}
                name="estatus"
                disabled={action.consult}
                aria-label="Default select example"
              >
                <option>Selecciona...</option>
                <option value="active">Activo</option>
                <option value="inactive">Inactivo</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Role</Form.Label>
              <Form.Select
                onChange={handleDataForm}
                name="role"
                value={dataForm.role}
                disabled={action.consult}
                aria-label="Default select example"
              >
                <option>Selecciona...</option>
                <option value="admin">Admin</option>
                <option value="basic">Basic</option>
                <option value="super">Supervisor</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Permisos</Form.Label>
              <div className="d-flex justify-content-start gap-2">
                <Form.Check
                  name="mexico"
                  disabled={action.consult}
                  checked={paises.mexico}
                  onChange={handlePaises}
                  type="checkbox"
                  label="México"
                />
                <Form.Check
                  name="colombia"
                  disabled={action.consult}
                  checked={paises.colombia}
                  onChange={handlePaises}
                  type="checkbox"
                  label="Colombia"
                />
                <Form.Check
                  name="peru"
                  disabled={action.consult}
                  checked={paises.peru}
                  onChange={handlePaises}
                  type="checkbox"
                  label="Perú"
                />
                <Form.Check
                  name="chile"
                  disabled={action.consult}
                  checked={paises.chile}
                  onChange={handlePaises}
                  type="checkbox"
                  label="Chile"
                />
              </div>
            </Form.Group>

            <div className="d-flex gap-3 justify-content-start align-items-center">
            <button className="btn btn-outline-success" type="submit">
              {action.create && "Crear Usuario"}
              {action.edit && "Editar Usuario"}
              {action.consult && "Consultar Usuario"}
            </button>
            <button className="btn btn-outline-danger" type="reset">
                Limpiar
            </button>
            </div>
          </div>
        )}
      </Form>
    </div>
  );
};

export default CreateEditMonitorUser;
